import React from 'react'
import NavBar from '../components/Home/NavBar';

const Blog = () => {
  return (
    <div>
        <NavBar />
    </div>
  )
}

export default Blog